export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'hh:mm A';
export const TIME_FORMAT_SEC = 'hh:mm:ss A';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY, hh:mm A';
export const DATE_TIME_CALC_FORMAT = 'YYYY-MM-DD HH:mm:ss UTC';
export const DAYS_HOURS_MINS_FORMAT = 'DD:HH:mm';
export const YEAR_MONTH_DAY_FORMAT = 'YYYY-MM-DD';
export const YEAR_MONTH_DAY_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const YEAR_MONTH_FORMAT = 'YYYY-MM';
export const FULL_MONTH_YEAR_FORMAT = 'MMMM YYYY';
export const YEAR_MONTH_DAY_TIME_FORMAT2 = 'MM/DD/YYYY HH:mm';
export const YEAR_MONTH_DAY_TIME_FORMAT3 = 'YYYY-MM-DDTHH:mm:ss';
export const MONTH_DATE_FORMAT = 'MMM DD';
